<app-lfsa-card-v2 *ngIf="!mostrarFormulario" [innTemplateButton]="innTemplateButton" [innTemplate]="enviarTemplate"
                  [modulo]="'VMI'" [tituloCard]="'Pedidos'" [titulo]="'Pedidos'">
</app-lfsa-card-v2>
<ng-template #innTemplateButton>
  <!--<div class="col-md-6">
    <div class="pagetitle">
      <div class="btn-group-justified btn-group" style="float: right;">
        <a (click)="nuevo()" class="btn btn-outline-success">
          <span class="fa fa-plus"></span>
          PEDIDOS
        </a>
        <a class="btn btn-outline-warning btn-outline"><i class="far fa-file-excel"></i></a>
      </div>
    </div>
  </div>-->
</ng-template>
<ng-template #enviarTemplate>
  <form [formGroup]="formulario" class="form-group" novalidate>
    <br>
  <section class="section">
    <div class="row">
      <div class="col-md-4">
        <app-lfsa-input [claseLabel]="'letrasDanger'" [control]="formulario.get('fechaInicio')" [id]="'fechaInicio'" [label]="'Fecha Inicio*'"
                        [placeholder]="'Fecha Inicio'" [type]="'date'" formControlName="fechaInicio">
        </app-lfsa-input>
      </div>
      <div class="col-md-4">
        <app-lfsa-input [claseLabel]="'letrasDanger'" [control]="formulario.get('fechaFinal')" [id]="'fechaFinal'" [label]="'Fecha Fin*'"
                        [placeholder]="'Fecha'" [type]="'date'" formControlName="fechaFinal">
        </app-lfsa-input>
      </div>
      <div class="col-md-4">
        <label for=""></label><br>
        <button (click)="buscarPorFecha()" [disabled]="formulario.invalid" [tooltip]="'BUSCAR/GRAFICAR'"
                class="btn btn-success btn-block"><i class="fa fa-search"></i></button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 ">
        <app-lfsa-alerts [listaVacia]="listaVacia" [loading]="loading" [texto]="'No existen elementos de pedidos.'">
        </app-lfsa-alerts>
        <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" *ngIf="!listaVacia"
                         [columnDefs]="columnDefs" [floatingFilter]="true" [frameworkComponents]="frameworkComponents " [localeText]="AG_GRID_LOCALE_ES"
                         [pagination]="true"
                         [rowData]="rowData" [rowSelection]="rowSelection" [style]="modulo.agGrid.style"
                         class="ag-theme-alpine" [paginationPageSize]="modulo.agGrid.paginacion">
        </ag-grid-angular>
      </div>
    </div>
  </section>
  </form>
</ng-template>

<app-lfsa-card-v2 *ngIf="mostrarFormulario" [innTemplate]="enviarTemplateForm" [modulo]="'Flete'"
                  [tituloCard]="order" [titulo]="'Visualizar Flete Driv In'">
</app-lfsa-card-v2>
<ng-template #enviarTemplateForm>
  <br>
  <section class="section">
    
      <div class="row" *ngIf="!listaVacia">
        <div class="col-md-6">
          <br>
          <label><h3><b>Orden:</b> {{ order }}</h3></label>
        </div>
        <div class="col-md-4">
          <br>
          <label><b>ESTADO:</b> {{ estado }}</label>
        </div>
        <div class="col-md-2">
          <label for=""></label><br>
          <button (click)="abrirLink()"  [disabled]="this.urlPdf === null" [tooltip]="'EXPORTAR PDF'" class="btn btn-success btn-block" *ngIf="!listaVacia"><i
            class="fa fa-file-pdf"></i></button>
        </div>
      </div>
    
    <hr>
    <div class="row" *ngIf="!listaVacia">
      <div class="col-md-4">
        <label><b>Cod. cliente:</b> {{ cabeceraSegui.codCliente }}</label>
        <label><b>Cliente:</b> {{ cabeceraSegui.nomCliente }}</label>
        <label><b>Entrega estimada en:</b> {{cabeceraSegui.direccion }} • {{ cabeceraSegui.horaEstimada }}</label>
      </div>
      <div class="col-md-2">
        <label>     </label>
        <label><b>{{ cabeceraSegui.estadoRuta }}</b></label>
        <label>{{ cabeceraSegui.esquema }}, {{ cabeceraSegui.ciudad }}</label>
      </div>
      <div class="col-md-6">
        <label><b>Esquema:</b> {{ cabeceraSegui.esquema }}</label>
        <br>
        <label><b>Dirección del Esquema:</b> {{cabeceraSegui.direccionEsquema}}</label>
      </div>
    </div>
    <hr>
    <ul class="nav nav-tabs" id="myTab" role="tablist">
      <li class="nav-item" role="presentation">
        <button aria-controls="home" aria-selected="true" class="nav-link active" data-bs-target="#home" data-bs-toggle="tab"
                id="home-tab" role="tab" type="button">Historial y Detalle
        </button>
      </li>
    </ul>
    <div class="tab-content" id="myTabContent">
      <div aria-labelledby="home-tab" class="tab-pane fade show active" id="home" role="tabpanel">
        <div class="row">
          <app-lfsa-alerts [listaVacia]="listaVacia" [loading]="loading"></app-lfsa-alerts>
          <div class="col-md-6">
            <div class="card" *ngIf="!listaVacia">
              <div class="card-header">
                <h5>Historial</h5>
              </div>
              <div class="card-body">
                <ag-grid-angular #agGrid (gridReady)="onGridSeguiReady($event)" *ngIf="!listaVacia"
                               [columnDefs]="columnSeguiDefs" [floatingFilter]="false" [frameworkComponents]="frameworkSeguiComponents " [localeText]="AG_GRID_LOCALE_ES"
                               [pagination]="true" [rowData]="rowSeguiData" [rowSelection]="rowSeguiSelection" [rowHeight]=120
                               [style]="modulo.agGrid.style" class="ag-theme-alpine"
                               [paginationPageSize]="$any(modulo.agGrid).paginacion">
              </ag-grid-angular>
              </div>
            </div>
            
          </div>
          <div class="col-md-6">
            
              <div class="card" *ngIf="!listaVacia">
                <div class="card-header">
                  <h5>Detalle</h5>
                </div>
                <div class="card-body">
                  <ag-grid-angular #agGrid (gridReady)="onGridItemReady($event)" 
                               [columnDefs]="columnItemDefs" [floatingFilter]="true" [frameworkComponents]="frameworkItemsComponents " [localeText]="AG_GRID_LOCALE_ES"
                               [pagination]="true" [rowData]="rowItemsData" [rowSelection]="rowItemsSelection" [rowHeight]=100
                               [style]="modulo.agGrid.style" class="ag-theme-alpine" autoHeaderHeight=true
                               [paginationPageSize]="$any(modulo.agGrid).paginacion">
                </ag-grid-angular>
                </div>
              </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label for=""></label><br>
            <button (click)="regresar()"  [tooltip]="'Regresar'" class="btn btn-danger btn-block" ><i
              class="fa fa-arrow-left"></i></button>
          </div>
        </div>
      </div>
    </div>
  </section>
</ng-template>


